<div class="abort-modal-container">
  <div class="abort-modal-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
      <path d="M12 3 1.5 21h21L12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M12 9.5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="17" r="1" fill="currentColor" />
    </svg>
  </div>

  <h4 class="abort-modal-title">Leave the wizard?</h4>

  <p class="abort-modal-body">
    Everything you&rsquo;ve entered for this world will be lost. <strong>This can&rsquo;t be undone.</strong>
  </p>

  <div class="btn-wrapper">
    <button type="button" class="btn btn-outline" [disabled]="isCancelling" (click)="cancel()">Keep editing</button>
    <button type="button" class="btn btn-danger" [disabled]="isCancelling" (click)="confirm()">
      @if (isCancelling) {
        <span class="abort-modal-spinner" aria-hidden="true"></span>
        Leaving&hellip;
      } @else {
        Yes, leave
      }
    </button>
  </div>
</div>
